module.exports = __webpack_public_path__ + "img/CT.a6721892.png";